module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dHiTc"))).then(() => parcelRequire('hEqeo'));